"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAppDispatcher = exports.AppDispatcher = void 0;
class AppDispatcher {
}
exports.AppDispatcher = AppDispatcher;
function makeAppDispatcher() {
    return new AppDistpatcherImp();
}
exports.makeAppDispatcher = makeAppDispatcher;
class AppDistpatcherImp extends AppDispatcher {
    constructor() {
        super(...arguments);
        this.registerHostHandler = (hostHandler) => {
            this.hostHandler = hostHandler;
        };
        this.dispatch = (request) => {
            if (!this.hostHandler) {
                console.error("[AppDispatcher] No host handler has been registered");
                return;
            }
            this.hostHandler(request);
        };
        this.stateHasChanged = (stateObject, assets, validationErrorMessage) => {
            const payload = {
                stateObject,
                assets,
                validationErrorMessage,
            };
            this.formRequestAndDispatch("ON_STATE_CHANGE", 3, payload);
        };
        this.stateIsCompleted = () => {
            this.formRequestAndDispatch("ON_STATE_COMPLETED", 1);
        };
        this.getAppAssetsURL = () => {
            return new Promise((resolve, reject) => {
                const callback = (url) => {
                    if (!url) {
                        reject(new Error("URL to asset folder is empty"));
                    }
                    else {
                        resolve(url);
                    }
                };
                const payload = {
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("GET_APP_ASSET_URL", 1, payload);
                }
            });
        };
        this.registerExternalStylesheets = (stylesheets) => {
            const payload = {
                stylesheets,
            };
            this.formRequestAndDispatch("REGISTER_EXTERNAL_STYLESHEETS", 1, payload);
        };
        this.appIsReady = () => {
            this.formRequestAndDispatch("APP_IS_READY", 1);
        };
        this.submitLog = (sender, message) => {
            const payload = {
                sender,
                severity: "LOG",
                message,
            };
            this.formRequestAndDispatch("SUBMIT_LOG", 1, payload);
        };
        this.log = (sender, message) => {
            const payload = {
                sender,
                severity: "LOG",
                message,
            };
            this.formRequestAndDispatch("SUBMIT_LOG", 1, payload);
        };
        this.logWarnign = (sender, message) => {
            const payload = {
                sender,
                severity: "WARNING",
                message,
            };
            this.formRequestAndDispatch("SUBMIT_LOG", 1, payload);
        };
        this.logError = (sender, message) => {
            const payload = {
                sender,
                severity: "ERROR",
                message,
            };
            this.formRequestAndDispatch("SUBMIT_LOG", 1, payload);
        };
        this.logFatalError = (sender, message) => {
            const payload = {
                sender,
                severity: "FATAL",
                message,
            };
            this.formRequestAndDispatch("SUBMIT_LOG", 1, payload);
        };
        this.submitHitResult = (success, description) => {
            const payload = {
                resultType: "HIT_V1",
                description,
                result: {
                    success,
                },
            };
            this.formRequestAndDispatch("SUBMIT_RESULTS", 3, payload);
        };
        this.submitProgressResult = (progress, description) => {
            const payload = {
                resultType: "PROGRESS_V1",
                description,
                result: {
                    progress,
                },
            };
            this.formRequestAndDispatch("SUBMIT_RESULTS", 3, payload);
        };
        this.submitMultiHitResult = (hits, misses, unanswered, description) => {
            const payload = {
                resultType: "MULTIHIT_V1",
                description,
                result: {
                    hits,
                    misses,
                    unanswered,
                },
            };
            this.formRequestAndDispatch("SUBMIT_RESULTS", 3, payload);
        };
        this.submitQualityResult = (stars, maxStars, description) => {
            const payload = {
                resultType: "QUALITY_V1",
                description,
                result: {
                    stars,
                    maxStars,
                },
            };
            this.formRequestAndDispatch("SUBMIT_RESULTS", 3, payload);
        };
        this.submitScoreResult = (score, maxScore, description) => {
            const payload = {
                resultType: "SCORE_V1",
                description,
                result: {
                    score,
                    maxScore,
                },
            };
            this.formRequestAndDispatch("SUBMIT_RESULTS", 3, payload);
        };
        this.getAssetBlobURL = (assetID) => {
            return new Promise((resolve, reject) => {
                const callback = (blobURL) => {
                    if (blobURL === undefined) {
                        reject(new Error("Blob URL is undefined"));
                    }
                    else {
                        resolve(blobURL);
                    }
                };
                const payload = {
                    assetID,
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("GET_ASSET_BLOB", 1, payload);
                }
            });
        };
        this.getAssetMeta = (assetID) => {
            return new Promise((resolve, reject) => {
                const callback = (assetMeta) => {
                    if (assetMeta === undefined) {
                        reject(new Error("Meta is undefined"));
                    }
                    else {
                        resolve(assetMeta);
                    }
                };
                const payload = {
                    assetID,
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("GET_ASSET_META", 1, payload);
                }
            });
        };
        this.getLinkedAssets = (assetID, type) => {
            return new Promise((resolve, reject) => {
                const callback = (linkedAssets) => {
                    if (linkedAssets === undefined) {
                        reject(new Error("Linked asset list is missing"));
                    }
                    else {
                        resolve(linkedAssets);
                    }
                };
                const payload = {
                    assetID,
                    type,
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("GET_LINKED_ASSETS", 1, payload);
                }
            });
        };
        this.getAssetsForOwner = (ownerID) => {
            return new Promise((resolve, reject) => {
                const callback = (assetMetas) => {
                    resolve(assetMetas);
                };
                const payload = {
                    ownerID,
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("GET_ASSET_FOR_OWNER", 1, payload);
                }
            });
        };
        this.submitNewActivityAsset = (file) => {
            return new Promise((resolve, reject) => {
                const callback = (assetID) => {
                    if (assetID) {
                        resolve(assetID);
                    }
                    else {
                        reject(new Error("Failed to get asset ID"));
                    }
                };
                const payload = {
                    file,
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("NEW_ACTIVITY_ASSET", 1, payload);
                }
            });
        };
        this.goToPreviousState = () => {
            this.formRequestAndDispatch("GO_TO_PREVIOUS_STATE", 1);
        };
        this.goToNextState = () => {
            this.formRequestAndDispatch("GO_TO_NEXT_STATE", 1);
        };
        this.stopZSpace = () => {
            this.formRequestAndDispatch("STOP_ZSPACE", 1);
        };
        this.hasNextState = () => {
            return new Promise((resolve, reject) => {
                const callback = (hasNextState) => {
                    resolve(hasNextState);
                };
                const payload = {
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("HAS_NEXT_STATE", 1, payload);
                }
            });
        };
        this.hasPreviousState = () => {
            return new Promise((resolve, reject) => {
                const callback = (hasPreviousState) => {
                    resolve(hasPreviousState);
                };
                const payload = {
                    callback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("HAS_PREVIOUS_STATE", 1, payload);
                }
            });
        };
        this.showAlert = (data) => {
            const payload = {
                title: data.title,
                message: data.message,
                closeButtonLabel: data.closeButtonLabel,
                closeCallback: data.closeCallback,
            };
            this.formRequestAndDispatch("SHOW_ALERT", 1, payload);
        };
        this.showConfirm = (data) => {
            const payload = {
                title: data.title,
                message: data.message,
                confirmCallback: data.confirmCallback,
                cancelButtonLabel: data.cancelButtonLabel,
                cancelCallback: data.cancelCallback,
                confirmButtonLabel: data.confirmButtonLabel,
            };
            this.formRequestAndDispatch("SHOW_CONFIRM", 1, payload);
        };
        this.showMarkDownEditor = (data) => {
            const payload = {
                initialText: data.initialText,
                submitCallback: data.submitCallback,
            };
            if (data.validateString) {
                payload.validateString = data.validateString;
            }
            this.formRequestAndDispatch("SHOW_MARKDOWN_EDITOR", 1, payload);
        };
        this.showSelectModel = (callback) => {
            const payload = {
                callback,
            };
            this.formRequestAndDispatch("SHOW_SELECT_MODEL", 1, payload);
        };
        this.isAssetFetched = (data) => {
            const payload = {
                assetId: data.assetId,
                callback: data.callback,
            };
            this.formRequestAndDispatch("IS_ASSET_FILE_FETCHED", 1, payload);
        };
        this.showSpinner = (data) => {
            return new Promise((resolve, reject) => {
                const closeCallback = (closeSpinner) => {
                    resolve(closeSpinner);
                };
                const payload = {
                    message: data.message,
                    title: data.title,
                    closeCallback,
                };
                if (!this.hostHandler) {
                    reject(new Error("No host handler has been registered"));
                }
                else {
                    this.formRequestAndDispatch("SHOW_SPINNER", 1, payload);
                }
            });
        };
    }
    formRequestAndDispatch(type, version, payload) {
        const request = {
            type,
            version,
            payload,
        };
        this.dispatch(request);
    }
}
